import { DATABASE_CACHE_KEY } from 'src/database/constants.ts';
import { UserSettings } from 'src/types/UserSettings.ts';
import { CachedValue } from 'src/database/databaseClient.ts';
import { createDatabaseProviderState } from 'src/database/createDatabaseProviderState.ts';
import { DatabaseProviderState } from 'src/database/types.ts';
import { checkDatabaseViaWorker } from 'src/database/checkDatabaseViaWorker.ts';
import { buildLoadDatabaseUrl } from 'src/database/buildLoadDatabaseUrl.ts';

export const handleRegularLoad = async (
    databaseCache: LocalForage,
    userSettings: UserSettings,
    uri: string,
    callback: (state: DatabaseProviderState) => void,
    assetDomain: string,
): Promise<void> => {
    let dbCache = new Map();
    const cacheFromStorage = await databaseCache.getItem<Map<string, CachedValue>>(DATABASE_CACHE_KEY);
    if (cacheFromStorage) {
        dbCache = cacheFromStorage;
    }
    let state;
    try {
        state = await createDatabaseProviderState(
            dbCache,
            databaseCache,
            userSettings,
            uri,
            assetDomain,
        );
        callback(state);
    } finally {
        const checkDbResult = await checkDatabaseViaWorker(buildLoadDatabaseUrl(uri, userSettings));
        if (checkDbResult) {
            const newState = await createDatabaseProviderState(
                new Map(),
                databaseCache,
                userSettings,
                uri,
                assetDomain,
            );
            callback(newState);
            if (state) {
                await state.dbClient.close();
            }
        }
    }
};
